var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7192,
    cy: 10.7192,
    r: 10.7192,
    fill: "#6EF1D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6179 9.7855C14.6179 6.75831 12.9896 5.72857 11.4667 5.49905C11.4667 5.48354 11.4698 5.46803 11.4698 5.44942C11.4698 5.06792 11.1317 4.76396 10.7192 4.76396C10.3066 4.76396 9.98098 5.06792 9.98098 5.44942C9.98098 5.46803 9.98098 5.48354 9.98408 5.49905C8.45808 5.73167 6.82042 6.76451 6.82042 9.7917C6.82042 13.3214 5.94266 13.6998 4.76404 14.6923H16.6743C15.5019 13.6967 14.6179 13.3152 14.6179 9.7855Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7253 16.6744C11.5565 16.6744 12.2389 16.0571 12.3288 15.3407H9.12177C9.20861 16.0571 9.89407 16.6744 10.7253 16.6744Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActive);
export default __webpack_public_path__ + "static/media/BellActive.9d7e0a4cc1d9ea73a5345f925ccb6594.svg";
export { ForwardRef as ReactComponent };